const partners_data = [
	{
		id: 0,
		icon: 'created',
		text: '305,000+ NFTs created',
	},
	{
		id: 1,
		icon: 'star',
		text: 'Rated the best NFT Marketplace',
	},
	{
		id: 2,
		icon: 'user',
		text: '1.6M+ Happy NFT Users',
	},
];

const works_data = [
	{
		id: '0Generate Revenue',
		text: 'Generate Revenue',
		icon: 'revenue',
		title: 'Generate Revenue',
	},
	{
		id: '1Reach Millions',
		text: 'Reach Millions',
		icon: 'peoples',
		title: 'Reach Millions',
	},
	{
		id: '2Spend Less',
		text: 'Spend Less',
		icon: 'wallet',
		title: 'Spend Less',
	},
	{
		id: '3Gas-free Marketplace',
		text: 'Gas-free Marketplace',
		icon: 'gas-free',
		title: 'Gas-free Marketplace',
	},
	{
		id: '4Advertise NFTWORLD',
		text: 'Advertise NFTWORLD',
		icon: 'advertise',
		title: 'Advertise NFTWORLD',
	},
	{
		id: '5Earn 20% Commission Per Sale!',
		text: 'Earn 20% Commission Per Sale!',
		icon: 'commission',
		title: 'Earn 20% Commission Per Sale!',
	},
];

export { partners_data, works_data };
